<template>
  <div class="events">
    <el-form
      ref="form"
      style="margin-bottom: 0;"
      :model="form"
      label-position="left"
      label-width="100px"
    >
      <el-form-item label="事项选择" style="line-height: 45px;">
        <el-radio-group @change="regionChange" v-model="form.region">
          <el-radio label="已有事项"></el-radio>
          <el-radio label="自定义事项"></el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.region === '自定义事项'">
        <el-form-item label="是否应急任务" style="line-height: 45px;">
          <el-radio-group v-model="form.sfyjsx">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="责任人类型" style="line-height: 45px;">
          <el-radio-group v-model="form.zrrlx">
            <el-radio
              v-for="(item, index) in zrrlxOptions"
              :key="index"
              :label="item.data.itemName"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="事项名称">
          <el-input
            v-model="form.eventName"
            placeholder="请输入事项名称"
          ></el-input>
        </el-form-item>
      </template>
    </el-form>
    <div v-if="form.region === '已有事项'" class="table-list">
      <el-form
        :inline="true"
        label-position="left"
        class="demo-form-inline"
        :model="searform"
      >
        <el-form-item label="">
          <el-select
            filterable
            placeholder="事项类型"
            clearable
            style="width: 120px;"
            v-model="searform.ghEventTypeId"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.sxlx"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            filterable
            placeholder="是否应急事项"
            clearable
            style="width: 144px;"
            v-model="searform.sfyjsx"
          >
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            filterable
            placeholder="责任人类型"
            clearable
            style="width: 144px;"
            v-model="searform.zrrlx"
          >
            <el-option
              v-for="item in zrrlxOptions"
              :key="item.id"
              :label="item.data.itemName"
              :value="item.data.itemName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="searform.sxmc"
            clearable
            placeholder="请输入事项名称"
            style="width:428px;"
          >
            <el-button
              style=" background: #0495FF;
                          border-radius: 0px 4px 4px 0px;
                          color: #FFFFFF;"
              slot="append"
              icon="el-icon-search"
              @click="eventPageFun"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="table-top-btns">
        <div class="left-btn">
          <div class="select-number">
            当前选中
            <span style="color: #3666EA;">{{ selectedIdOptions.length }}</span>
            条
          </div>
        </div>
      </div>
      <common-table
        :select="true"
        :isShowPagination="false"
        :dataList="dataList"
        :maxHeight="320"
        :selectedIdOptions="selectedIdOptions"
        @handleSelectionChange="handleSelectionChange"
        @selectAll="selectAll"
      >
      </common-table>
    </div>
    <div v-if="form.region === '自定义事项'" class="index-list">
      <div class="title">
        <span style="margin-right: 14px;">任务指标</span>
        <el-button
          type="text"
          @click="openDrawer({}, true)"
          class="el-icon-plus"
          >添加</el-button
        >
      </div>
      <div class="index" v-if="ghEventIndexList.length">
        <div
          class="index-item"
          :class="{ active: curId == index }"
          v-for="(item, index) in ghEventIndexList"
          :key="index"
          @click="curId = index"
        >
          <div>{{ item.zbsm }}</div>
          <div class="edit-btns" v-if="curId == index">
            <el-button
              type="text"
              @click="openDrawer(item, false, index)"
              style="color: #0090FF;font-size: 16px;"
              class="el-icon-edit"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click=""
              style="color: #EB3538;font-size: 16px;"
              class="el-icon-delete"
              @click="delghEventIndexListFun(index)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <div style="text-align: center;">
          <img src="@/assets/image/empty.png" alt="" />
          <div>暂无数据</div>
          <div class="btns">
            点击<el-button type="text" @click="openDrawer({}, true)"
              >添加任务指标</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <indexDrawer
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
      @updateData="updateData"
    ></indexDrawer>
  </div>
</template>

<script>
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import indexDrawer from "./indexDrawer";
import { eventPage, selList } from "@/api/base.js";
import { dictItemRoot } from "@/api/systemManagement.js";
export default {
  components: {
    commonTable,
    indexDrawer
  },
  mixins: [pageChangeSelect],
  props: {
    eventsInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        eventName: "",
        region: "已有事项",
        zrrlx: "",
        sfyjsx: "是"
      },
      searform: {
        ghEventTypeId: "",
        sfyjsx: "",
        zrrlx: "",
        sxmc: ""
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "ghEventTypeName",
            label: "事项类型"
          },
          {
            prop: "sxmc",
            label: "事项名称"
          },
          {
            prop: "ghEventTypeSfyjsx",
            label: "是否应急事项"
          },
          {
            prop: "zrrlx",
            label: "责任人类型"
          }
        ]
      },
      ghEventIndexList: [],
      curId: 0,
      dialogVisible: false,
      curItem: {},
      typeList: [],
      zrrlxOptions: []
    };
  },
  mounted() {
    this.selectedIdOptions = this.eventsInfo.selectedIdOptions || [];
    this.ghEventIndexList = this.eventsInfo.ghEventIndexList || [];
    this.form = JSON.parse(JSON.stringify(this.eventsInfo.form));
    this.selListFun();
    this.dictItemRootFun();
    this.eventPageFun();
  },
  methods: {
    regionChange() {
      this.$emit("regionChange")
    },
    openDrawer(item, isAdd, index) {
      this.curItem = {
        ...item,
        isAdd,
        index
      };
      this.dialogVisible = true;
    },
    updateData(item) {
      if (item.isAdd) this.ghEventIndexList.unshift(item);
      else this.ghEventIndexList[item.index] = { ...item };
    },
    delghEventIndexListFun(index) {
      this.ghEventIndexList.splice(index, 1);
    },
    nextStepsFun() {
      let eventsInfo = {
        eventsList: [],
        selectedIdOptions: [],
        ghEventIndexList: [],
        form: {
          eventName: "",
          region: "已有事项",
          zrrlx: "",
          sfyjsx: "是"
        }
      };
      if (this.form.region == "已有事项") {
        if (!this.selectedOptions.length) {
          this.$message({
            type: "error",
            message: "请先选择事项指标"
          });
          return;
        }
        eventsInfo.eventsList = this.selectedOptions.map(item => {
          return {
            eventMangerId: item.id,
            sxmc: item.sxmc
          };
        });
        eventsInfo.selectedIdOptions = this.selectedIdOptions;
      } else if (this.form.region == "自定义事项") {
        if (!this.form.eventName) {
          this.$message({
            type: "error",
            message: "请输入事项名称"
          });
          return;
        }
        eventsInfo.form = {
          eventName: this.form.eventName,
          region: "自定义事项",
          zrrlx: this.form.zrrlx,
          sfyjsx: this.form.sfyjsx
        };
        eventsInfo.eventsList = [
          {
            sxmc: this.form.eventName,
            eventMangerId: ''
          }
        ];
        eventsInfo.ghEventIndexList = this.ghEventIndexList;
      }
      this.$emit("updateEventsData", eventsInfo);
    },
    // 事项类型
    async selListFun() {
      const res = await selList({
        sxlx: ""
      });
      this.typeList = res.data.data || [];
    },
    // 责任人类型
    async dictItemRootFun() {
      const res = await dictItemRoot({
        dictType: "GH_ZRRLX",
        data: true,
        page: 1,
        size: 9999,
        pid: -1
      });
      this.zrrlxOptions = res.data.data.dataList || [];
    },

    // 分页查询
    async eventPageFun() {
      let params = {
        sxmc: this.searform.sxmc,
        sfyjsx: this.searform.sfyjsx,
        zrrlx: this.searform.zrrlx,
        ghEventTypeId: this.searform.ghEventTypeId,
        page: 1,
        size: 99999
      };
      const res = await eventPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
@import "~@/components/less.less";
.events {
  height: 100%;
  width: 100%;
  // overflow: auto;
  .table-list {
    height: calc(100% - 70px);
    width: 100%;
    position: relative;
  }
  .index-list {
    height: calc(100% - 270px);
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 18px;
      color: #494c4f;
    }
    .index {
      height: calc(100% - 40px);
      width: 100%;
      overflow: auto;
      .index-item {
        width: 100%;
        background: #f7faff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 16px;
        cursor: pointer;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        .edit-btns {
          margin-top: 6px;
          display: flex;
        }
      }
      .index-item.active {
        background: #f7faff url("~@/assets/image/zbbg.png") right center
          no-repeat;
        background-size: 272px 100%;
        border-radius: 4px;
        border: 1px solid #0090ff;
      }
    }
    .empty {
      height: calc(100% - 40px);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #494c4f;
      img {
        height: 126px;
      }
      .btns {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: #92979c;
        margin-top: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/events.vue